import { render, staticRenderFns } from "./PaywaitScreen.vue?vue&type=template&id=679353e4"
import script from "./PaywaitScreen.vue?vue&type=script&lang=js"
export * from "./PaywaitScreen.vue?vue&type=script&lang=js"
import style0 from "./PaywaitScreen.vue?vue&type=style&index=0&id=679353e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports